// Renders a headline with the portion AFTER the delimiter painted in
// champagne gold.
//
// Two delimiters are supported:
//   "|"   inline gold tail (default behaviour, original API)
//   "||"  the gold tail is forced onto its own block line
//
// If no delimiter is present, the text is returned unchanged.
//
// Usage:
//   <h1>{accent(t.about.title)}</h1>
import React from "react";

export function accent(text, goldClass = "text-champagne") {
  if (typeof text !== "string") return text;

  // Force-break delimiter "||" wins over inline "|".
  const breakIdx = text.indexOf("||");
  if (breakIdx !== -1) {
    const head = text.slice(0, breakIdx).trimEnd();
    const tail = text.slice(breakIdx + 2).trimStart();
    return (
      <>
        {head}
        <span className={`${goldClass} block`}>{tail}</span>
      </>
    );
  }

  const idx = text.indexOf("|");
  if (idx === -1) return text;
  const head = text.slice(0, idx).trimEnd();
  const tail = text.slice(idx + 1).trimStart();
  return (
    <>
      {head}
      {head ? " " : ""}
      <span className={goldClass}>{tail}</span>
    </>
  );
}
